import { vsObjectName as mealLogObjectName } from "../../configs/mealLog";

import {
  FormViewConfig,
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../records/forms/formView";
import { StateService } from "@uirouter/angularjs";
import { Injectable } from "angular";

export function resolveMealLogForm(
  title: string,
  modelFactory: Injectable<(...args: any[]) => any>,
  afterSubmitOrCancelSref: string
) {
  return {
    formViewConfig: [
      FormViewServiceName,
      (formViewService: FormViewService) =>
        formViewService.getFormViewConfig(mealLogObjectName),
    ],
    fields: [
      "formViewConfig",
      (formViewConfig: FormViewConfig) => formViewConfig.fields,
    ],
    model: modelFactory,
    title: [() => title],
    onSubmit: [
      "formViewConfig",
      "$state",
      (formViewConfig: FormViewConfig, $state: StateService) => [
        "model",
        "formViewController",
        (model: any, formViewController: FormViewController) =>
          formViewConfig.submitForm!({ model, formViewController }).then(() =>
            $state.go(afterSubmitOrCancelSref, undefined, { reload: true })
          ),
      ],
    ],
    onCancel: [
      "$state",
      ($state: StateService) => [() => $state.go(afterSubmitOrCancelSref)],
    ],
  };
}
